import { get } from './base/index';

export default {
  validarCupom: (codigo) => get(`/cupom/validar/${codigo}`),
};
